import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundSection = styled.section`
  background: transparent;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
`;

const NotFoundContent = styled.div`
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 5rem 4rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.12);
  }
  
  @media (max-width: 768px) {
    padding: 3rem 2rem;
    margin: 1rem;
  }
`;

const NotFoundTitle = styled.h1`
  font-size: 6rem;
  font-weight: 800;
  background: linear-gradient(135deg, #7359B3 0%, #593399 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 4rem;
  }
`;

const NotFoundSubtitle = styled.h2`
  font-size: 1.75rem;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.3;
`;

const NotFoundText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 3rem;
  font-size: 1.2rem;
  line-height: 1.7;
  font-weight: 400;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const NotFound = () => {
  return (
    <NotFoundSection>
      <div className="container">
        <NotFoundContent>
          <NotFoundTitle>404</NotFoundTitle>
          <NotFoundSubtitle>Page Not Found</NotFoundSubtitle>
          <NotFoundText>
            Sorry, the page you're looking for doesn't exist. 
            It might have been moved, deleted, or you entered the wrong URL.
          </NotFoundText>
          <Link to="/" className="cta-button">
            Go Home
          </Link>
        </NotFoundContent>
      </div>
    </NotFoundSection>
  );
};

export default NotFound;
